export default {
  transStatus(transStatus, trans_status) {
    transStatus.commit('transStatus', trans_status)
  },
  transUrl(transUrl, trans_url) {
    transUrl.commit('transUrl', trans_url)
  },
  urlIsNull(urlIsNull, Boole) {
    urlIsNull.commit('urlIsNull', Boole)
  },
  urlIsNo(urlIsNo, Boole) {
    urlIsNo.commit('urlIsNo', Boole)
  },
  loading(loading, Boole) {
    loading.commit('loading', Boole)
  },
  timeOut(timeOut, Boole) {
    timeOut.commit('timeOut', Boole)
  },
  userInputUrl(userInputUrl, user_input_url) {
    userInputUrl.commit('userInputUrl', user_input_url)
  },
  searchUrl(searchUrl, search_url) {
    searchUrl.commit('searchUrl', search_url)
  }
}